import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID, // Application (client) ID from Azure
    // authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MS_TENANT_ID}`, // Directory (tenant) ID
    authority: `https://login.microsoftonline.com/common`, // Directory (tenant) ID
    redirectUri: "https://compelion.com/", // URL after successful login
  },
  cache: {
    cacheLocation: "localStorage", // Caching the token in localStorage
    storeAuthStateInCookie: false, // Use cookies if required
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);